import { render, staticRenderFns } from "./ForemanDetail.vue?vue&type=template&id=b5b59f12&scoped=true"
import script from "./ForemanDetail.vue?vue&type=script&lang=js"
export * from "./ForemanDetail.vue?vue&type=script&lang=js"
import style0 from "./ForemanDetail.vue?vue&type=style&index=0&id=b5b59f12&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b59f12",
  null
  
)

export default component.exports